import { Injectable } from '@angular/core';
import { DialogModel } from './models/dialog.model';
import { BaseModalDialogComponent } from './base-modal-dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Injectable({
  providedIn: 'root'
})
export class BaseModalDialogService {

  constructor(
    protected bsModalService: BsModalService
  ) { }

  openDialog(data: DialogModel, classes = '') {
    this.bsModalService
      .show(BaseModalDialogComponent, {initialState: data, backdrop: 'static', class: classes});
  }
}
